import styled from 'styled-components';
import { Container } from '@agilize/components-core';
import { device } from '@styles/tools/breakpoints.styles';

export const ChildrenStyles = styled(Container)`
  max-width: 1240px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
  padding: 0 ${props => props.theme.global.gutterSpace * 1.25}px 0;

  ${device.mobile} {
    max-width: 100vw;
    padding: 0 ${props => props.theme.global.gutterSpace * 0.75}px 0;
  }
`;

export const ChildrenMain = styled(ChildrenStyles)`
  margin-top: 72px;
`;
